export type IFormLinkSelect = (
  fieldFormLinkId: string,
  dataBundleId: string,
  displayValue: string,
  suffix?: string
) => void;

export function formLinkSelect(
  fieldFormLinkId: string,
  dataBundleId: string,
  displayValue: string,
  suffix?: string
): void {
  let _suffix = typeof window.fieldSuffix !== 'undefined' ? window.fieldSuffix : '';
  if (suffix) {
    _suffix = suffix;
  }
  const inputSelector = `:input[name="field_${fieldFormLinkId}${_suffix}"]`;
  const siblingAutoinputSelector = `:input[name="auto_field_${fieldFormLinkId}${_suffix}"]`;
  const $input = $(inputSelector);
  const $autoInput = $(siblingAutoinputSelector);
  const $modal = $(`#formlink-search-modal-${fieldFormLinkId}`);

  $input.val(dataBundleId).trigger('change');
  $autoInput.val(displayValue);

  window.DexeroCoreApp.showFormGroupSuccess($input);

  $modal.modal('hide');
}
